import { render, staticRenderFns } from "./svgIconBase.vue?vue&type=template&id=07c95b97&"
import script from "./svgIconBase.vue?vue&type=script&lang=js&"
export * from "./svgIconBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports